import { gql } from '@apollo/client';

export const GET_INSTITUTION_VALIDATION = gql`
  query getInstitutionValidation($id: ID) {
    institution: getInstitutionValidation(id: $id) {
      id
      validated
    }
  }
`;
